module.exports = __webpack_public_path__ + "img/product_7.4316f35.jpg";